import { render, staticRenderFns } from "./BasicForm.vue?vue&type=template&id=7d0e9431&scoped=true&"
import script from "./BasicForm.vue?vue&type=script&lang=js&"
export * from "./BasicForm.vue?vue&type=script&lang=js&"
import style0 from "./BasicForm.vue?vue&type=style&index=0&id=7d0e9431&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d0e9431",
  null
  
)

export default component.exports